import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const VideoOffIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M14.2581 1.85355C14.4534 1.65829 14.4534 1.34171 14.2581 1.14645C14.0628 0.951184 13.7463 0.951184 13.551 1.14645L0.550988 14.1464C0.355725 14.3417 0.355725 14.6583 0.550988 14.8536C0.74625 15.0488 1.06283 15.0488 1.25809 14.8536L14.2581 1.85355Z"
      fill="currentColor"
    />
    <path
      d="M8.53051 4.04559H4.29604C3.2491 4.04559 2.40039 4.8943 2.40039 5.94124V10.1757L8.53051 4.04559Z"
      fill="currentColor"
    />
    <path
      d="M5.76997 12.463H9.89604C10.943 12.463 11.7917 11.6143 11.7917 10.5673V9.04151C11.8188 9.06926 11.8476 9.09595 11.8782 9.12142L13.9578 10.8544C14.693 11.467 15.8091 10.9443 15.8091 9.98734V6.52133C15.8091 5.56438 14.693 5.04162 13.9578 5.65424L11.8782 7.38724C11.8476 7.41272 11.8188 7.4394 11.7917 7.46716V6.44126L5.76997 12.463Z"
      fill="currentColor"
    />
  </svg>
);
